import { Trans } from 'react-i18next'

import { SEARCH_TAB_TYPE } from '~/types/search'
import { SearchTab } from '~/types/ui.components'

export const SEARCH_URL = '/services/api/search?index'

export const searchTabs: SearchTab[] = [{
  title: <Trans i18nKey="components.ui.searchModal.tabs.all" />,
  type: SEARCH_TAB_TYPE.ALL
}, {
  title: <Trans i18nKey="components.ui.searchModal.tabs.docs" />,
  type: SEARCH_TAB_TYPE.DOCS
}, {
  title: <Trans i18nKey="components.ui.searchModal.tabs.apis" />,
  type: SEARCH_TAB_TYPE.APIS
}, {
  title: <Trans i18nKey="components.ui.searchModal.tabs.endpoints" />,
  type: SEARCH_TAB_TYPE.OPERATIONS
}, {
  title: <Trans i18nKey="components.ui.searchModal.tabs.schemas" />,
  type: SEARCH_TAB_TYPE.SCHEMAS
}]